(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goodwe-creator-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('goodwe-creator-reviews')) {
  customElements.define('goodwe-creator-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.gw-creators__track');
      this.controls = this.querySelector('.gw-creators__controls');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.controls.hidden = max < 2;
        this.buttons[0].disabled = offset <= 4;
        this.buttons[1].disabled = offset >= max - 4;
      };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const direction = Number(button.dataset.direction);
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * rtl * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      this.track.addEventListener('scroll', this.onScroll, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.gw-creators__card');
        if (card) this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goodwe-footer-pro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goodwe-footer-pro')) {
    class GoodWeFooterPro extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.menus = Array.from(this.querySelectorAll('[data-footer-menu]'));
        this.onBreakpointChange = this.syncMenus.bind(this);
        this.syncMenus();
        this.mobileQuery.addEventListener('change', this.onBreakpointChange);
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.onBreakpointChange);
      }

      syncMenus() {
        this.menus.forEach((menu) => {
          menu.open = !this.mobileQuery.matches;
        });
      }
    }

    customElements.define('goodwe-footer-pro', GoodWeFooterPro);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goodwe-top-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goodwe-top-banner')) {
    class GoodWeTopBanner extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.gw-top-banner__slide'));
        this.pauseButton = this.querySelector('.gw-top-banner__pause');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.delay = Number(this.dataset.delay) || 5000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.userPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onVisibilityChange = this.handleVisibilityChange.bind(this);

        this.pauseButton?.addEventListener('click', () => this.togglePause());
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        if (this.dataset.pauseOnHover === 'true') {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.start();
          });
        }

        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const selectedSlide = event.target.closest('.gw-top-banner__slide');
            const selectedIndex = this.slides.indexOf(selectedSlide);
            if (selectedIndex >= 0) this.show(selectedIndex);
            this.stop();
          });
        }

        this.show(this.index);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      show(nextIndex) {
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a, button').forEach((element) => {
            if (active) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', '-1');
          });
        });
        this.index = nextIndex;
      }

      next() {
        this.show((this.index + 1) % this.slides.length);
      }

      start() {
        this.stop();
        if (!this.autoplay || this.userPaused || this.reducedMotion || this.slides.length < 2 || document.hidden) return;
        this.timer = window.setInterval(() => this.next(), this.delay);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.pauseButton?.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton?.setAttribute('aria-label', this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
        if (this.userPaused) this.stop();
        else this.start();
      }

      handleVisibilityChange() {
        if (document.hidden) this.stop();
        else this.start();
      }
    }

    customElements.define('goodwe-top-banner', GoodWeTopBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllers = new WeakMap();
    const selector = '.gw-slideshow-section ecx-slideshow';

    const initialize = (root) => {
      root.querySelectorAll(selector).forEach(async (slideshow) => {
        await customElements.whenDefined('ecx-slideshow');
        if (!slideshow.isConnected || controllers.has(slideshow)) return;

        const track = slideshow.querySelector('.js-slideshow-items');
        const pagination = slideshow.querySelector('.js-slideshow-pagination');
        const buttons = pagination?.querySelectorAll('.gw-slideshow-dot');
        if (!track || !pagination || !buttons?.length) return;
        const controller = new AbortController();
        controllers.set(slideshow, controller);
        const options = { signal: controller.signal };
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const enabled = Boolean(slideshow.properties.autoplay) && buttons.length > 1;
        const duration = Math.max(1000, Number(slideshow.properties.duration) || 5000);
        const nativeStop = slideshow.stopAutoPlay;
        const nativeStart = slideshow.startAutoPlay;
        const nativeResume = slideshow.resumeAutoPlay;
        nativeStop.call(slideshow);
        let timer;
        let animation;
        let activeIndex;
        let hovered = false;
        let keyboardFocus = false;
        let touching = false;
        let inView = false;
        let pointerGesture;

        const syncImageLinks = () => {
          track.querySelectorAll('.gw-slideshow-image-link').forEach((link) => {
            link.tabIndex = link.closest('.js-slideshow-item').getAttribute('aria-hidden') === 'false' ? 0 : -1;
          });
        };
        track.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.button !== 0) return;
          pointerGesture = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: track.scrollLeft, moved: false, ended: 0 };
        }, options);
        track.addEventListener('pointermove', (event) => {
          if (pointerGesture?.id !== event.pointerId) return;
          if (Math.hypot(event.clientX - pointerGesture.x, event.clientY - pointerGesture.y) > 8) pointerGesture.moved = true;
        }, options);
        const finishGesture = (event) => {
          if (pointerGesture?.id === event.pointerId) pointerGesture.ended = performance.now();
        };
        document.addEventListener('pointerup', finishGesture, options);
        document.addEventListener('pointercancel', finishGesture, options);
        track.addEventListener('click', (event) => {
          if (!event.target.closest('.gw-slideshow-image-link') || event.detail === 0 || !pointerGesture) return;
          const recent = !pointerGesture.ended || performance.now() - pointerGesture.ended < 800;
          if (recent && (pointerGesture.moved || Math.abs(track.scrollLeft - pointerGesture.scroll) > 8)) event.preventDefault();
          pointerGesture = undefined;
        }, { ...options, capture: true });
        const linkObserver = new MutationObserver(syncImageLinks);
        linkObserver.observe(track, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
        syncImageLinks();

        const pause = () => {
          clearTimeout(timer);
          animation?.pause();
          slideshow.autoplay = false;
          slideshow.dataset.gwPaused = 'true';
          track.setAttribute('aria-live', 'polite');
        };

        const resume = () => {
          if (!enabled || motion.matches || document.hidden || hovered || keyboardFocus || touching || !inView) {
            pause();
            return;
          }
          clearTimeout(timer);
          slideshow.autoplay = true;
          slideshow.dataset.gwPaused = 'false';
          track.setAttribute('aria-live', 'off');
          animation?.play();
          const elapsed = Number(animation?.currentTime) || 0;
          timer = setTimeout(() => {
            slideshow.nextSlide();
            timer = setTimeout(resetProgress, 700);
          }, Math.max(0, duration - elapsed));
        };

        const resetProgress = () => {
          clearTimeout(timer);
          animation?.cancel();
          buttons.forEach((button) => {
            const active = button.closest('li').classList.contains('is-active');
            if (active) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
            button.querySelector('.gw-slideshow-fill').style.transform = active && (!enabled || motion.matches) ? 'scaleX(1)' : 'scaleX(0)';
          });
          const fill = pagination.querySelector('.is-active .gw-slideshow-fill');
          animation = enabled && !motion.matches && fill
            ? fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration, fill: 'forwards', easing: 'linear' })
            : undefined;
          animation?.pause();
          resume();
        };

        const syncPagination = () => {
          const next = pagination.querySelector('.is-active')?.dataset.slideshowIndex;
          if (next === activeIndex) return;
          activeIndex = next;
          resetProgress();
        };

        slideshow.stopAutoPlay = pause;
        slideshow.startAutoPlay = resume;
        slideshow.resumeAutoPlay = resume;

        pagination.addEventListener('click', (event) => {
          const button = event.target.closest('.gw-slideshow-dot');
          if (!button) return;
          const target = Array.from(track.children).filter((slide) =>
            slide.querySelector('.js-slideshow-image')?.dataset.slideshowIndex === button.dataset.gwSlide
          ).sort((a, b) => Math.abs(a.offsetLeft - track.scrollLeft) - Math.abs(b.offsetLeft - track.scrollLeft))[0];
          if (!target) return;
          pause();
          track.scrollTo({ left: target.offsetLeft, behavior: motion.matches ? 'auto' : 'smooth' });
          if (button.getAttribute('aria-current') === 'true') resetProgress();
        }, options);

        slideshow.addEventListener('mouseenter', () => { hovered = true; pause(); }, options);
        slideshow.addEventListener('mouseleave', () => { hovered = false; resume(); }, options);
        slideshow.addEventListener('focusin', (event) => {
          keyboardFocus = event.target.matches(':focus-visible');
          if (keyboardFocus) pause();
        }, options);
        slideshow.addEventListener('focusout', (event) => {
          if (!slideshow.contains(event.relatedTarget)) { keyboardFocus = false; resume(); }
        }, options);
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') { touching = true; pause(); }
        }, options);
        const release = () => { if (touching) { touching = false; resume(); } };
        document.addEventListener('pointerup', release, options);
        document.addEventListener('pointercancel', release, options);
        document.addEventListener('visibilitychange', resume, options);
        motion.addEventListener('change', resetProgress, options);

        const observer = new MutationObserver(syncPagination);
        observer.observe(pagination, { subtree: true, attributes: true, attributeFilter: ['class'] });
        const viewportObserver = new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
          resume();
        }, { threshold: 0.1 });
        viewportObserver.observe(slideshow);
        controller.signal.addEventListener('abort', () => {
          pause();
          animation?.cancel();
          observer.disconnect();
          viewportObserver.disconnect();
          linkObserver.disconnect();
          slideshow.stopAutoPlay = nativeStop;
          slideshow.startAutoPlay = nativeStart;
          slideshow.resumeAutoPlay = nativeResume;
          controllers.delete(slideshow);
        }, { once: true });
        syncPagination();
        slideshow.dataset.gwProgressReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((slideshow) => controllers.get(slideshow)?.abort());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
